import React from "react";
import { Seo } from "../components/Seo";
import { Link } from "react-router-dom";
import { SOLUTIONS, INDUSTRIES, FINAL_CTA } from "../mock";
import { PageHero, Reveal, SectionHeader, DarkCTA } from "../components/Shared";

const Solutions = () => (
  <>
    <Seo title="Solutions by industry — Pharmacy, e-commerce, QSR, 3PL & more" description="How pharmacies, retailers, restaurants, 3PLs and field teams run deliveries and fleets on Fleetroot." />
    <PageHero
      eyebrow="Solutions"
      title="Built for what you move."
      subtitle="Parcels, prescriptions, pallets or people — the same platform, configured for your operation."
      primary={{ label: "Request a demo", to: "/contact" }}
    />

    {SOLUTIONS.map((s, i) => (
      <section
        key={s.slug}
        id={s.slug}
        className={`section ${i % 2 === 0 ? "bg-[var(--fr-bg-alt)]" : ""}`}
        data-testid={`solution-${s.slug}`}
      >
        <div className="container-x grid md:grid-cols-2 gap-12 items-center">
          <Reveal className={`card card-hover p-3 ${i % 2 === 1 ? "md:order-2" : ""}`}>
            <div className="img-tile aspect-[4/3]">
              <img src={s.image} alt={s.name} loading="lazy" style={s.imagePosition ? { objectPosition: s.imagePosition } : undefined} />
              <span className="absolute top-3 left-3 chip bg-white/90 backdrop-blur">{s.kind}</span>
            </div>
          </Reveal>
          <Reveal delay={120} className={i % 2 === 1 ? "md:order-1" : ""}>
            <span className="eyebrow">{s.kind}</span>
            <h2 className="h-section mt-4">{s.name}</h2>
            <p className="mt-3 font-display text-xl text-[var(--fr-primary-dark)] font-semibold">{s.tagline}</p>
            <p className="mt-5 text-lg text-[var(--fr-ink-2)] leading-relaxed">{s.body}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <span key={t} className="chip">
                  {t}
                </span>
              ))}
            </div>
            <Link to="/contact" className="btn btn-primary mt-8" data-testid={`solution-cta-${s.slug}`}>
              Talk to a specialist
            </Link>
          </Reveal>
        </div>
      </section>
    ))}

    <section className="section" data-testid="industries">
      <div className="container-x">
        <SectionHeader eyebrow="Industries" title="Who runs on Fleetroot" subtitle="Retail, e-commerce, grocery, healthcare, distribution and field service operations that rely on reliable last-mile execution." />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={(i % 3) * 70} className="card card-hover p-6">
              <h3 className="font-display font-bold text-lg">{ind.name}</h3>
              <p className="mt-2 text-[15px] text-[var(--fr-ink-2)] leading-relaxed">{ind.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <DarkCTA title={FINAL_CTA.title} text={FINAL_CTA.text} cta={FINAL_CTA.cta} email={FINAL_CTA.email} />
  </>
);

export default Solutions;
